/**
 * tdesign v1.1.1
 * (c) 2023 tdesign
 * @license MIT
 */

import { _ as _defineProperty } from '../_chunks/dep-8c8a3203.js';
import { _ as _slicedToArray } from '../_chunks/dep-605e961c.js';
import React, { useContext } from 'react';
import classNames from 'classnames';
import useConfig from '../hooks/useConfig.js';
import useDomRefCallback from '../hooks/useDomRefCallback.js';
import useRipple from '../_util/useRipple.js';
import { MenuContext } from './MenuContext.js';
import '../_chunks/dep-f66447d3.js';
import '../config-provider/ConfigContext.js';
import '../_chunks/dep-1d5f47c2.js';
import '../_chunks/dep-8670d51c.js';
import '../_chunks/dep-df9f8f04.js';
import '../_chunks/dep-9d326786.js';
import '../_chunks/dep-3542b5f1.js';
import '../_chunks/dep-79aca757.js';
import '../_chunks/dep-c7d784af.js';
import '../_chunks/dep-2055661d.js';
import '../_chunks/dep-73c3cd54.js';
import '../_chunks/dep-ced835e2.js';
import '../_chunks/dep-1e76a561.js';
import '../_chunks/dep-6b33e1e9.js';
import '../_chunks/dep-dae4a585.js';
import '../_chunks/dep-9e05eaf2.js';
import '../_chunks/dep-0d617aaa.js';
import '../_chunks/dep-030d278c.js';
import '../_chunks/dep-868937ef.js';
import '../_chunks/dep-6f5c07a7.js';
import '../_chunks/dep-a79a1775.js';
import '../_chunks/dep-7b744c82.js';
import '../_chunks/dep-0b20126b.js';
import '../_chunks/dep-2b7035c1.js';
import '../locale/zh_CN.js';
import '../_common/js/global-config/locale/zh_CN.js';
import 'dayjs';
import '../_chunks/dep-4fce6f2f.js';
import '../_common/js/global-config/default-config.js';
import '../_util/useAnimation.js';
import '../_util/setStyle.js';
import '../_util/dom.js';
import 'raf';
import '../_chunks/dep-378695bd.js';
import '../_util/easing.js';
import '../_util/noop.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
var MenuItem = function MenuItem(props) {
  var _classNames;
  var content = props.content,
    _props$children = props.children,
    children = _props$children === void 0 ? content : _props$children,
    disabled = props.disabled,
    href = props.href,
    _props$target = props.target,
    target = _props$target === void 0 ? "_self" : _props$target,
    value = props.value,
    className = props.className,
    style = props.style,
    icon = props.icon,
    onClick = props.onClick;
  var _useConfig = useConfig(),
    classPrefix = _useConfig.classPrefix;
  var _useDomRefCallback = useDomRefCallback(),
    _useDomRefCallback2 = _slicedToArray(_useDomRefCallback, 2),
    menuItemDom = _useDomRefCallback2[0],
    setRefCurrent = _useDomRefCallback2[1];
  useRipple(menuItemDom);
  var _useContext = useContext(MenuContext),
    onChange = _useContext.onChange,
    setState = _useContext.setState,
    active = _useContext.active;
  var handleClick = function handleClick(e) {
    e.stopPropagation();
    if (disabled) return;
    onClick && onClick({
      e: e
    });
    onChange(value);
    setState({
      active: value
    });
  };
  return /* @__PURE__ */React.createElement("li", {
    ref: setRefCurrent,
    className: classNames("".concat(classPrefix, "-menu__item"), className, (_classNames = {}, _defineProperty(_classNames, "".concat(classPrefix, "-is-disabled"), disabled), _defineProperty(_classNames, "".concat(classPrefix, "-is-active"), value === active), _defineProperty(_classNames, "".concat(classPrefix, "-menu__item--plain"), !icon), _classNames)),
    style: _objectSpread({}, style),
    onClick: handleClick
  }, /* @__PURE__ */React.createElement(React.Fragment, null, icon, href ? /* @__PURE__ */React.createElement("a", {
    href: href,
    target: target,
    className: classNames("".concat(classPrefix, "-menu__item-link"))
  }, /* @__PURE__ */React.createElement("span", {
    className: "".concat(classPrefix, "-menu__content")
  }, children)) : /* @__PURE__ */React.createElement("span", {
    className: "".concat(classPrefix, "-menu__content")
  }, children)));
};
MenuItem.displayName = "MenuItem";

export { MenuItem as default };
//# sourceMappingURL=MenuItem.js.map
